module.exports = __webpack_public_path__ + "img/camera_black.260b91c1.svg";